import { DiscountTypeKind } from "@relay/discountActionsTable_DiscountActionFragment.graphql";

export const DISCOUNT_TYPE_OPTIONS: Array<{ label: string; value: DiscountTypeKind }> = [
	{ label: "System", value: "System" },
	{ label: "Nutzer", value: "User" },
];
